// extracted by mini-css-extract-plugin
module.exports = {"resetActionContainer":"PasswordReset_resetActionContainer__iTYHD"};